import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../utils/string-helper';

@Pipe({
  name: 'eventoTime'
})
export class EventoTimePipe implements PipeTransform {

  transform(value: string, args?: any): string {
    const date = new Date(value);
    return value === null ? '' : StringHelper.formatTime(date.getHours(), date.getMinutes());
  }

}
